import { createColorClasses } from "@/theme/colors";
import clsx from "clsx";
import { IconProps } from "../../types/icons";

export const UserGroup = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "User group",
  onClick,
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5555 2.24414C14.1176 2.24414 12.9555 3.42095 12.9555 4.86838V6.68656C12.9555 8.13399 14.1176 9.31081 15.5555 9.31081C16.9933 9.31081 18.1555 8.13399 18.1555 6.68656V4.86838C18.1555 3.42095 16.9933 2.24414 15.5555 2.24414ZM13.9555 4.86838C13.9555 3.97279 14.6737 3.2502 15.5555 3.2502C16.4372 3.2502 17.1555 3.97279 17.1555 4.86838V6.68656C17.1555 7.58216 16.4372 8.30475 15.5555 8.30475C14.6737 8.30475 13.9555 7.58216 13.9555 6.68656V4.86838Z"
        fill="#0066CC"
      />
      <path
        d="M15.5555 9.51687C12.7922 9.51687 10.5555 11.7791 10.5555 14.5654V14.7654H11.5555V14.5654C11.5555 12.3309 13.3482 10.5229 15.5555 10.5229C17.7627 10.5229 19.5555 12.3309 19.5555 14.5654V14.7654H20.5555V14.5654C20.5555 11.7791 18.3188 9.51687 15.5555 9.51687Z"
        fill="#0066CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35547 16.7896C6.91764 16.7896 5.75547 17.9664 5.75547 19.4138V21.232C5.75547 22.6794 6.91764 23.8563 8.35547 23.8563C9.7933 23.8563 10.9555 22.6794 10.9555 21.232V19.4138C10.9555 17.9664 9.7933 16.7896 8.35547 16.7896ZM6.75547 19.4138C6.75547 18.5182 7.4737 17.7957 8.35547 17.7957C9.23723 17.7957 9.95547 18.5182 9.95547 19.4138V21.232C9.95547 22.1276 9.23723 22.8502 8.35547 22.8502C7.4737 22.8502 6.75547 22.1276 6.75547 21.232V19.4138Z"
        fill="#0066CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7555 16.7896C21.3176 16.7896 20.1555 17.9664 20.1555 19.4138V21.232C20.1555 22.6794 21.3176 23.8563 22.7555 23.8563C24.1933 23.8563 25.3555 22.6794 25.3555 21.232V19.4138C25.3555 17.9664 24.1933 16.7896 22.7555 16.7896ZM21.1555 19.4138C21.1555 18.5182 21.8737 17.7957 22.7555 17.7957C23.6372 17.7957 24.3555 18.5182 24.3555 19.4138V21.232C24.3555 22.1276 23.6372 22.8502 22.7555 22.8502C21.8737 22.8502 21.1555 22.1276 21.1555 21.232V19.4138Z"
        fill="#0066CC"
      />
      <path
        d="M8.35547 24.0623C5.59215 24.0623 3.35547 26.3245 3.35547 29.1108V29.3108H4.35547V29.1108C4.35547 26.8763 6.14822 25.0684 8.35547 25.0684C10.5627 25.0684 12.3555 26.8763 12.3555 29.1108V29.3108H13.3555V29.1108C13.3555 26.3245 11.1188 24.0623 8.35547 24.0623Z"
        fill="#0066CC"
      />
      <path
        d="M22.7555 24.0623C19.9922 24.0623 17.7555 26.3245 17.7555 29.1108V29.3108H18.7555V29.1108C18.7555 26.8763 20.5482 25.0684 22.7555 25.0684C24.9627 25.0684 26.7555 26.8763 26.7555 29.1108V29.3108H27.7555V29.1108C27.7555 26.3245 25.5188 24.0623 22.7555 24.0623Z"
        fill="#0066CC"
      />
    </svg>
  );
};
